<template>
    <div 
        :class="['a-p-list-header', first ? 'a-p-list-header--first' : '']"
    >
        <div class="a-p-list-header__title">
            {{title}}
        </div>
        <div class="a-p-list-header__floor">
            {{ $t(params.floor, 'Plan')}}
        </div>
        <div class="a-p-list-header__nr">
            {{ $t(params.nr, 'Nr.') }}
        </div>
    </div>
</template>

<script>

export default {
    name: 'APListHeader',
    props: {
        first: {
            type: Boolean,
            default: false
        },
        title: {
            type: String,
            require: true
        },
        params: {
            type: Object,
            default: () => ({})
        }
    }
}
</script>

<style lang="scss">
@import "a-p-list-header";
</style>
